/*
    Custom JavaScript for Spotessence Theme
*/

// ===== FUNCIONALIDAD DE COMUNAS PARA EL CARRITO =====
console.log('🚀 Cargando funcionalidad de comunas en custom.js');

// Función para normalizar caracteres especiales (tildes y ñ)
function normalizeText(text) {
  if (!text) return text;

  return text
    .normalize('NFD') // Descompone los caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Elimina los diacríticos (tildes)
    .replace(/ñ/g, 'n') // Reemplaza ñ minúscula
    .replace(/Ñ/g, 'N'); // Reemplaza Ñ mayúscula
}

// Datos de regiones y comunas
window.comunasData = {
  cities: {
    "AP": "Arica y Parinacota",
    "TA": "Tarapacá",
    "AN": "Antofagasta",
    "AT": "Atacama",
    "CO": "Coquimbo",
    "VS": "Valparaíso",
    "RM": "Región Metropolitana",
    "LI": "O'Higgins",
    "ML": "Maule",
    "NB": "Ñuble",
    "BI": "Biobio",
    "AR": "Araucanía",
    "LR": "Los Ríos",
    "LL": "Los Lagos",
    "AI": "Aysén",
    "MA": "Magallanes"
  },
  times: {
    "AP": "3 a 7 días hábiles aprox",
    "TA": "3 a 7 días hábiles aprox",
    "AN": "3 a 7 días hábiles aprox",
    "AT": "3 a 7 días hábiles aprox",
    "CO": "3 a 5 días hábiles aprox",
    "VS": "2 a 5 días hábiles aprox",
    "RM": "2 a 5 días hábiles aprox",
    "LI": "3 a 5 días hábiles aprox",
    "ML": "3 a 5 días hábiles aprox",
    "NB": "3 a 5 días hábiles aprox",
    "BI": "3 a 5 días hábiles aprox",
    "AR": "3 a 5 días hábiles aprox",
    "LR": "3 a 5 días hábiles aprox",
    "LL": "3 a 5 días hábiles aprox",
    "AI": "3 a 7 días hábiles",
    "MA": "hasta 10 días hábiles"
  },
  towns: {
    "AN": ["Antofagasta", "Calama", "Maria Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"],
    "AR": ["Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautin", "Curarrehue", "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay", "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre las Casas", "Perquenco", "Pitrufquen", "Pucon", "Puren", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt", "Tolten", "Traiguen", "Victoria", "Vilcun", "Villarrica"],
    "AP": ["Arica", "Camarones", "General Lagos", "Putre"],
    "AT": ["Alto del Carmen", "Caldera", "Chañaral", "Copiapo", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"],
    "AI": ["Aisen", "Chile Chico", "Cisnes", "Cochrane", "Coihaique", "Guaitecas", "Lago Verde", "O'Higgins", "Rio Ibañez", "Tortel"],
    "BI": ["Alto Biobio", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepcion", "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpen", "Hualqui", "Laja", "Lebu", "Los Alamos", "Los Angeles", "Lota", "Mulchen", "Nacimiento", "Negrete", "Penco", "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Barbara", "Santa Juana", "Talcahuano", "Tirua", "Tome", "Tucapel", "Yumbel"],
    "CO": ["Andacollo", "Canela", "Combarbala", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paihuano", "Punitaqui", "Rio Hurtado", "Salamanca", "Vicuña"],
    "LL": ["Ancud", "Calbuco", "Castro", "Chaiten", "Chonchi", "Cochamo", "Curaco de Velez", "Dalcahue", "Fresia", "Frutillar", "Futaleufu", "Hualaihue", "Llanquihue", "Los Muermos", "Maullin", "Osorno", "Palena", "Puerto Montt", "Puerto Octay", "Puerto Varas", "Puqueldon", "Purranque", "Puyehue", "Queilen", "Quellon", "Quemchi", "Quinchao", "Rio Negro", "San Juan de la Costa", "San Pablo"],
    "LR": ["Corral", "Futrono", "La Union", "Lago Ranco", "Lanco", "Los Lagos", "Mariquina", "Mafil", "Paillaco", "Panguipulli", "Rio Bueno", "Valdivia"],
    "MA": ["Antartica", "Cabo de Hornos (Ex Navarino)", "Laguna Blanca", "Natales", "Porvenir", "Primavera", "Punta Arenas", "Rio Verde", "San Gregorio", "Timaukel", "Torres del Paine"],
    "ML": ["Cauquenes", "Chanco", "Colbun", "Constitucion", "Curepto", "Curico", "Empedrado", "Hualañe", "Licanten", "Linares", "Longavi", "Maule", "Molina", "Parral", "Pelarco", "Pelluhue", "Pencahue", "Rauco", "Retiro", "Romeral", "Rio Claro", "Sagrada Familia", "San Clemente", "San Javier", "San Rafael", "Talca", "Teno", "Vichuquen", "Villa Alegre", "Yerbas Buenas"],
    "NB": ["Bulnes", "Chillan", "Chillan Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Pemuco", "Pinto", "Portezuelo", "Quillon", "Quirihue", "Ranquil", "San Carlos", "San Fabian", "San Ignacio", "San Nicolas", "Treguaco", "Yungay", "Ñiquen"],
    "LI": ["Chimbarongo", "Chepica", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machali", "Malloa", "Marchihue", "Mostazal", "Nancagua", "Navidad", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo", "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua", "Rengo", "Requinoa", "San Fernando", "San Vicente", "Santa Cruz"],
    "RM": ["Alhue", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchali", "Curacavi", "El Bosque", "El Monte", "Estacion Central", "Huechuraba", "Independencia", "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipu", "Maria Pinto", "Melipilla", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda", "Peñaflor", "Peñalolen", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquin", "San Jose de Maipo", "San Miguel", "San Pedro", "San Ramon", "Santiago", "Talagante", "Tiltil", "Vitacura", "Ñuñoa"],
    "TA": ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"],
    "VS": ["Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concon", "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernandez", "La Cruz", "La Ligua", "Limache", "Llaillay", "Los Andes", "Nogales", "Olmue", "Panquehue", "Papudo", "Petorca", "Puchuncavi", "Putaendo", "Quillota", "Quilpue", "Quintero", "Rinconada", "San Antonio", "San Esteban", "San Felipe", "Santa Maria", "Santo Domingo", "Valparaiso", "Villa Alemana", "Viña del Mar", "Zapallar"]
  }
};

// Función para inicializar los selectores de comunas
window.initComunasSelectors = function() {
  console.log('🚀 Iniciando selectores de comunas desde custom.js');

  const citySelect = document.getElementById('select-city');
  const townSelect = document.getElementById('select-town');

  if (!citySelect || !townSelect) {
    console.log('❌ Selectores no encontrados');
    return;
  }

  console.log('✅ Selectores encontrados, configurando...');

  // Cargar regiones
  loadRegions();

  // Event listeners usando delegación
  document.addEventListener('change', handleSelectChange);
};

function loadRegions() {
  const citySelect = document.getElementById('select-city');
  if (!citySelect) return;

  citySelect.innerHTML = '<option value="">Selecciona tu Región</option>';

  for (let code in window.comunasData.cities) {
    const option = document.createElement('option');
    option.value = code;
    option.textContent = window.comunasData.cities[code];
    citySelect.appendChild(option);
  }

  console.log('📍 Regiones cargadas:', Object.keys(window.comunasData.cities).length);
}

function loadTowns(regionCode) {
  const townSelect = document.getElementById('select-town');
  if (!townSelect) return;

  townSelect.innerHTML = '<option value="">Selecciona tu Comuna</option>';

  if (regionCode && window.comunasData.towns[regionCode]) {
    window.comunasData.towns[regionCode].forEach(town => {
      const option = document.createElement('option');
      option.value = town;
      option.textContent = town;
      townSelect.appendChild(option);
    });
    console.log('🏘️ Comunas cargadas:', window.comunasData.towns[regionCode].length);
  }
}

function handleSelectChange(e) {
  if (e.target.id === 'select-city') {
    console.log('🌍 Región seleccionada:', e.target.value);
    const regionCode = e.target.value;

    if (regionCode) {
      loadTowns(regionCode);
    }
  } else if (e.target.id === 'select-town') {
    console.log('🏘️ Comuna seleccionada:', e.target.value);
    const selectedTown = e.target.value;
    const citySelect = document.getElementById('select-city');
    const selectedRegion = citySelect ? citySelect.value : '';

    if (selectedTown && selectedRegion) {
      // Actualizar formulario
      updateCheckoutForm(selectedRegion, selectedTown);

      // Actualizar estilos
      document.querySelectorAll('.comunas select').forEach(select => {
        select.classList.remove('rojo');
        select.classList.add('verde');
      });

      const alertElement = document.querySelector('.comunas .alert');
      if (alertElement) {
        alertElement.style.display = 'none';
      }
    }
  }
}

function updateCheckoutForm(selectedRegion, selectedTown) {
  if (!selectedRegion || !selectedTown) return;

  // Normalizar los datos antes de enviarlos
  const normalizedProvince = normalizeText(window.comunasData.cities[selectedRegion]);
  const normalizedCity = normalizeText(selectedTown);

  const shippingAddress = {
    country: 'CL',
    province: normalizedProvince,
    city: normalizedCity,
    zip: '0000000'
  };

  // Actualizar carrito con datos normalizados
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        region: normalizedProvince,
        ciudad: normalizedCity
      }
    })
  })
  .then(response => response.json())
  .then(() => {
    // Buscar formulario tanto en la página del carrito como en el offcanvas
    const offcanvasForm = document.querySelector('#offcanvas-cart #cart-form');
    const pageForm = document.querySelector('#cart #cart-form');
    const form = offcanvasForm || pageForm;

    if (form) {
      console.log('📋 Formulario encontrado:', form.id || 'sin ID');

      // Limpiar campos existentes
      const existingFields = form.querySelectorAll('input[name^="checkout[shipping_address]"]');
      existingFields.forEach(field => field.remove());

      // Agregar nuevos campos con datos normalizados
      Object.entries(shippingAddress).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `checkout[shipping_address][${key}]`;
        input.value = value;
        form.insertBefore(input, form.firstChild);
      });

      // Crear URL con parámetros normalizados
      const params = new URLSearchParams({
        'checkout[shipping_address][country]': 'CL',
        'checkout[shipping_address][province]': normalizedProvince,
        'checkout[shipping_address][city]': normalizedCity,
        'checkout[shipping_address][zip]': '0000000'
      });

      // Actualizar la acción del formulario para incluir los parámetros
      if (offcanvasForm) {
        form.action = `/checkout?${params.toString()}`;
      } else if (pageForm) {
        // Para la página del carrito, actualizar el botón de checkout
        const checkoutBtn = form.querySelector('button[name="checkout"]');
        if (checkoutBtn) {
          checkoutBtn.onclick = function(e) {
            e.preventDefault();
            window.location.href = `/checkout?${params.toString()}`;
          };
        }
      }

      console.log('✅ Formulario actualizado con región normalizada:', normalizedProvince, 'y ciudad normalizada:', normalizedCity);
    } else {
      console.warn('⚠️ No se encontró formulario del carrito');
    }
  })
  .catch(error => console.error('❌ Error actualizando carrito:', error));
}

// Escuchar evento de actualización del carrito
window.addEventListener('updated.ecomify.cart', function() {
  console.log('🔄 Carrito actualizado, reinicializando selectores...');
  setTimeout(() => {
    window.initComunasSelectors();
  }, 200);
});

// Inicializar al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  console.log('📄 DOM listo, inicializando comunas...');
  window.initComunasSelectors();
});

// ===== FIN FUNCIONALIDAD DE COMUNAS =====
